import { getViewMore } from '@/common/requests/data-fetch/get-view-more'

export const useListViewMore = () => {
  const getListViewMoreHomeData = async (uiCode) => {
    try {
      const { data } = await getViewMore({ uiCode })
      return data
    } catch (error) {
      console.error(error)
    }
  }

  return {
    getListViewMoreHomeData,
  }
}
